import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu';
import { ActionMenuOption, AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { colors, spacing } from 'ui/theme';
import { SecondaryButton } from 'ui/button';
import { Edit16, View, Overflow, Add16 } from 'ui/icons';

const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;

export const displayContent = {
  edit: 'Edit use',
  changelog: 'View changelog',
  import: 'Import Projects/Orgs',
};

type TableActionsMenuProps = {
  handleEditClick: () => void;
  handleChangelogClick: () => void;
  handleImport: () => void;
};

export const TableActionMenu = ({
  handleEditClick,
  handleChangelogClick,
  handleImport,
}: TableActionsMenuProps) => {
  const overflowOptions: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Edit16 height={16} color={colors.grey50} />
          <span>{displayContent.edit}</span>
        </>
      ),
      id: 'make-a-copy',
      onClick: handleEditClick,
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Add16 height={18} color={colors.grey50} />
          <span>{displayContent.import}</span>
        </>
      ),
      id: 'import',
      onClick: handleImport,
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <View height={18} color={colors.grey50} />
          <span>{displayContent.changelog}</span>
        </>
      ),
      id: 'move',
      onClick: handleChangelogClick,
    },
  ];

  return (
    <ActionMenu
      align={MENU_ALIGNMENTS.RIGHT}
      options={overflowOptions}
      data-test="admin-app-feature-flags-actions"
    >
      <StyledButton>
        <Overflow color={colors.grey90} />
      </StyledButton>
    </ActionMenu>
  );
};
